import { Inject, Injectable, Optional } from '@angular/core';
import { API_PUBLIC_PREFIX } from '@core/config-angular';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { snakeCase, toHttpParams } from '@essent/common';
import type {
  GetTimesV1Data,
  GetTimesV1Response,
} from '@integration/api-client/feh';

@Injectable()
export class GetTimeslotsTimesService {
  public readonly apiVersion = '1';
  public readonly endpoint = `${this.apiUrl || ''}/feh/timeslots/times/v${
    this.apiVersion
  }`;

  public constructor(
    @Optional()
    @Inject(API_PUBLIC_PREFIX)
    private readonly apiUrl: string,
    private readonly httpClient: HttpClient
  ) {}

  public call$(payload: GetTimesV1Data): Observable<GetTimesV1Response> {
    const headers = { Accept: 'application/json' };
    return this.httpClient.get<GetTimesV1Response>(this.endpoint, {
      headers,
      params: toHttpParams(snakeCase(payload)),
    });
  }
}
